/** Persisted workspace org (admin target org + KB + GHL, etc.). Kept in sync with server via `X-Workspace-Organization-Id` on KB requests. */
export const WORKSPACE_ORG_STORAGE_KEY = "bb_workspace_organization_id";

export function readWorkspaceOrgIdFromStorage(): string | null {
  try {
    const v = localStorage.getItem(WORKSPACE_ORG_STORAGE_KEY);
    return v && v.trim() ? v.trim() : null;
  } catch {
    return null;
  }
}

export function writeWorkspaceOrgIdToStorage(id: string | null) {
  try {
    if (id) localStorage.setItem(WORKSPACE_ORG_STORAGE_KEY, id);
    else localStorage.removeItem(WORKSPACE_ORG_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
